export default __webpack_public_path__ + "static/media/C9.f32ffb98.png";